export const GROUP_LIST = 'GROUP_LIST';
